function ContactCard({ icon, label, value, href }) {
  return (
    <a
      className="contact-card"
      href={href}
      target={href?.startsWith("http") ? "_blank" : undefined}
      rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}
    >
      <div className="contact-card-icon">{icon}</div>

      <div>
        <div className="contact-card-label">{label}</div>

        <div className="contact-card-value">{value}</div>
      </div>
    </a>
  );
}

export default ContactCard;
